import React from 'react';
import { Event } from '../api';
import { formatTime, openMapsLink, openWebsite } from '../utils';

interface EventCardProps {
  event: Event;
}

export function EventCard({ event }: EventCardProps) {
  return (
    <div className="event-card">
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-xl font-bold text-gray-800">{event.title}</h3>
        <span className="text-2xl">🎉</span>
      </div>

      <div className="text-blue-600 font-semibold text-lg mb-2">
        {formatTime(event.start_time)}
        {event.end_time && ` - ${formatTime(event.end_time)}`}
        <span className="text-sm font-normal text-gray-600"> EST</span>
      </div>

      {event.description && !event.description.includes('Source:') && (
        <p className="text-gray-700 text-sm mb-3 line-clamp-2">{event.description}</p>
      )}

      <div className="space-y-2 mb-4 text-sm">
        {event.venue_name && (
          <div className="flex items-center gap-2 text-gray-700">
            <span>📍</span>
            <span>{event.venue_name}</span>
          </div>
        )}
        {event.venue_address && (
          <button
            onClick={() => openMapsLink(event.venue_name || '', event.venue_address)}
            className="text-blue-500 hover:text-blue-700 underline text-sm flex items-center gap-1"
          >
            <span>🗺️</span>
            Open in Maps
          </button>
        )}
      </div>

      <div className="flex gap-2 flex-wrap items-center">
        {event.url ? (
          <button
            onClick={() => openWebsite(event.url!)}
            className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded transition text-sm font-semibold"
          >
            Event Page →
          </button>
        ) : null}
        {event.source_url && (
          <button
            onClick={() => openWebsite(event.source_url!)}
            className="text-xs text-blue-600 hover:text-blue-800 hover:underline bg-blue-50 px-3 py-1 rounded transition"
          >
            ℹ️ View Source
          </button>
        )}
      </div>
    </div>
  );
}
